import * as d from "react";
import { i as m, E as b, x as g, d as v, c as x } from "../createReactComponent-58f9bea8.mjs";
import { n as c } from "../property-9daa16cd.mjs";
import { e as p } from "../class-map-2994e95e.mjs";
const h = m`
  :host {
    outline: none;
  }

  :host .tab-container {
    display: flex;
    gap: var(--exo-spacing-2x-small);
    flex-direction: column;
    border-radius: var(--exo-spacing-2x-small);
  }

  :host .tab-container:focus-visible {
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-action-hover);
  }

  :host .tab-container:active .tab-item {
    background: var(--exo-color-background-tertiary-selected-weak);
  }

  :host .tab-container.disabled:focus-visible,
  :host .tab-container.disabled:focus-visible .tab-item {
    outline: none;
    background: none;
  }

  :host .tab-item {
    display: flex;
    cursor: pointer;
    align-items: center;
    align-self: stretch;
    color: var(--exo-color-font);
    font: var(--exo-text-body-small);
    padding: var(--exo-spacing-2x-small) var(--exo-spacing-x-small);
    white-space: nowrap;
    gap: var(--exo-spacing-2x-small);
    height: 24px;
    border-radius: var(--exo-spacing-2x-small);
    justify-content: center;
  }

  :host .tab-item > :only-child {
    margin-right: 0; /* Reset gap/margin */
  }

  :host .tab-item:hover {
    background: var(--exo-color-background-action-hover-weak);
    transition: background 200ms ease-out;
  }

  :host .tab-container:focus-visible .tab-item {
    background: var(--exo-color-background-action-hover-weak);
    border-radius: var(--exo-spacing-none);
  }

  :host .tab-item--decorator,
  :host .tab-item--selected .tab-item--decorator {
    height: var(--exo-spacing-3x-small);
  }

  :host .tab-item--decorator {
    margin: var(--exo-spacing-none) var(--exo-spacing-x-small);
    transition: margin 200ms ease-out;
  }

  :host .tab-container:not(.tab-item--selected):hover .tab-item--decorator,
  :host
    .tab-container:not(.disabled):not(.tab-item--selected):focus-visible
    .tab-item--decorator {
    background: var(--exo-color-border);
    margin: var(--exo-spacing-none);
    animation: smart-animate 200ms ease-out;
  }

  :host .disabled .tab-item,
  :host .disabled ::slotted(ex-icon),
  :host .tab-container.disabled {
    pointer-events: none;
    color: var(--exo-color-background-disabled);
    user-select: none;
  }

  /* selected  styles */

  :host .tab-item--selected .tab-item,
  :host .compact.tab-item--selected:hover .tab-item,
  :host .compact.tab-item--selected:focus-visible .tab-item {
    color: var(--exo-color-font);
    font-weight: var(--exo-font-weight-semi-bold);
    transition: background 200ms ease-out;
    padding-left: calc(
      var(--exo-spacing-x-small) - var(--exo-spacing-4x-small)
    );
    padding-right: calc(
      var(--exo-spacing-x-small) - var(--exo-spacing-4x-small)
    );
  }

  :host .tab-item--selected:hover .tab-item,
  :host .tab-item--selected:focus-visible .tab-item {
    background: var(--exo-color-background-selected-weak);
  }

  :host .tab-item--selected:focus-visible {
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-selected);
  }

  :host .tab-item--selected .tab-item--decorator {
    margin: var(--exo-spacing-none) var(--exo-spacing-x-small);
    border-radius: var(--exo-spacing-3x-small);
    background: var(--exo-color-background-selected);
    transition: margin 200ms ease-out;
  }

  :host .tab-item--selected:hover .tab-item--decorator,
  :host .tab-item--selected:focus-visible .tab-item--decorator {
    margin: var(--exo-spacing-none);
    border-radius: var(--exo-spacing-none);
    animation: smart-animate 200ms ease-out;
  }

  ::slotted(ex-icon) {
    font-size: var(--exo-font-size-medium);
    color: var(--exo-color-background-deselected);
  }

  /* compact tab item styles */

  :host .compact .tab-item--decorator {
    display: none;
  }

  :host .compact.tab-item--selected,
  :host .compact.tab-item--selected .tab-item {
    background: var(--exo-color-background-selected-weak);
    color: var(--exo-color-background-selected);
  }

  @keyframes smart-animate {
    from {
      margin: var(--exo-spacing-none) var(--exo-spacing-x-small);
    }
    to {
      margin: var(--exo-spacing-none);
    }
  }
`;
var u = Object.defineProperty, f = Object.getOwnPropertyDescriptor, l = (e, a, i, s) => {
  for (var r, t = s > 1 ? void 0 : s ? f(a, i) : a, n = e.length - 1; n >= 0; n--)
    (r = e[n]) && (t = (s ? r(a, i, t) : r(t)) || t);
  return s && t && u(a, i, t), t;
}, k = ((e) => (e.DEFAULT = "default", e.COMPACT = "compact", e))(k || {});
class o extends b {
  constructor() {
    super(...arguments), this.selected = !1, this.disabled = !1, this.variant = "default";
  }
  handlePress(a) {
    a.code === "Enter" && (this.handleClick(), this.selected = !0);
  }
  handleClick() {
    this.dispatchCustomEvent("onClick");
  }
  render() {
    return g`
      <div
        class=${p({ "tab-container": !0, disabled: this.disabled, "tab-item--selected": this.selected, compact: this.variant === "compact" })}
        @click=${this.handleClick}
        @keypress=${this.handlePress}
        aria-disabled=${this.disabled ? "true" : "false"}
        tabindex="0"
      >
        <div class="tab-item" part="label">
          <slot></slot>
        </div>
        <div part="decorator" class="tab-item--decorator"></div>
      </div>
    `;
  }
}
o.styles = h, l([c({ type: Boolean, reflect: !0 })], o.prototype, "selected", 2), l([c({ type: Boolean, reflect: !0 })], o.prototype, "disabled", 2), l([c({ type: String })], o.prototype, "variant", 2);
const y = v("ex-tab-item", o), P = x({ tagName: "ex-tab-item", elementClass: o, react: d, events: { onClick: "onClick" }, displayName: "ExTabItem", registerWebComponent: y });
export {
  P as ExTabItem,
  k as TabItemVariant,
  y as register
};
